// extracted by mini-css-extract-plugin
export default {"matchEventLinks":"TournamentTabs_matchEventLinks__C31-k"};